/**
 * categorizeTransaction — Shared optimistic write + Cloud Function call
 *
 * Used by ReviewQueue swipe handler and CategorizationSheet.
 * Writes tpCategory + companion fields optimistically, then fires
 * the Cloud Function for rule learning and burn recalc.
 */

import { doc, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '@/firebase/config';

export async function categorizeTransaction(
  userId: string,
  transactionId: string,
  category: string,
): Promise<void> {
  const txnRef = doc(db, 'users', userId, 'transactions', transactionId);

  // Optimistic write — immediate UI update via onSnapshot
  // Only write fields allowed by Firestore rules; tpConfidence/tpReason
  // are written server-side by recategorizeTransaction Cloud Function.
  try {
    await updateDoc(txnRef, {
      tpCategory: category,
      tpConfirmedBy: 'user',
    });
  } catch (err) {
    console.warn('[categorizeTransaction] Optimistic write failed:', err);
  }

  // Server write — ALWAYS fires, even if optimistic write failed
  const recategorize = httpsCallable(functions, 'recategorizeTransaction');
  recategorize({ transactionId, tpCategory: category }).catch((err) => {
    console.error('[categorizeTransaction] Cloud Function failed:', err);
  });
}
